/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ListComponent_suggestions$ref: FragmentReference;
declare export opaque type ListComponent_suggestions$fragmentType: ListComponent_suggestions$ref;
export type ListComponent_suggestions = $ReadOnlyArray<{|
  +id: string,
  +name: string,
  +$refType: ListComponent_suggestions$ref,
|}>;
export type ListComponent_suggestions$data = ListComponent_suggestions;
export type ListComponent_suggestions$key = {
  +$data?: ListComponent_suggestions$data,
  +$fragmentRefs: ListComponent_suggestions$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ListComponent_suggestions",
  "type": "PicklistInterface",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cedc9c1831057ac00db01d7c946de2e2';
module.exports = node;
